<template>
  <div>
    <div id="admin-preloader" v-if="loading">
      <div id="admin-loader-text">Updating</div>
      <div id="admin-loader"></div>
    </div>
    <div id="admin-preloader" v-if="loading1">
      <div id="admin-loader-text">Loading</div>
      <div id="admin-loader"></div>
    </div>
    <div id="admin-preloader" v-if="loading2">
      <div id="admin-loader-text">Deleting</div>
      <div id="admin-loader"></div>
    </div>

    <div v-if="changed">
      <div class="m-auto text-right pt-3">
        <el-button
          @click="dialogFormVisible2 = true"
          type="primary"
          size="medium"
        >
          <i class="el-icon-plus mr-2"></i>Add Expense</el-button
        >
      </div>
      <div class="col-sm-12 col-md-8 col-lg-6 m-auto pl-4">
        <el-dialog
          title="Add Expense"
          :visible.sync="dialogFormVisible2"
          :width="width"
        >
          <!-- <h4 class="text-center pt-4 pb-3">Add Expense</h4> -->
          <el-card shadow="always" style="background-color: #f5f7fa">
            <el-form
              :model="formdata"
              status-icon
              :rules="rules2"
              ref="formdata"
              label-width="120px"
              :label-position="labelPosition"
              size="medium"
              style="
                <!-- border: 1px solid #e2e2e2;
                border-radius: 5px; -->
                background-color: #fff;
                padding: 25px;
              "
            >
              <el-form-item label="Store" prop="store">
                <el-select v-model="formdata.store" placeholder="Select Store">
                  <el-option
                    v-for="(store, i) in stores"
                    :key="i"
                    :value="store.id"
                    :label="store.name"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="Expense Main Category" prop="cat">
                <el-select
                  v-model="formdata.cat"
                  placeholder="Expense Main Category"
                >
                  <el-option
                    v-for="(cat, key) in expenseCategories"
                    :key="key"
                    :value="key"
                    >{{ key }}</el-option
                  >
                </el-select>
              </el-form-item>
              <el-form-item
                v-if="formdata.cat"
                label="Expense Sub Category"
                prop="subcat"
              >
                <el-select
                  v-model="formdata.subcat"
                  placeholder="Expense Sub Category"
                >
                  <el-option
                    v-for="(subcat, key) in expenseCategories[formdata.cat]"
                    :key="key"
                    :value="key"
                    >{{ key }}</el-option
                  >
                </el-select>
              </el-form-item>

              <el-form-item prop="date" label="Date">
                <el-date-picker
                  type="date"
                  :picker-options="{
                    disabledDate: (time) => disabledDate(time),
                  }"
                  placeholder="Pick a date"
                  v-model="formdata.date"
                ></el-date-picker>
              </el-form-item>

              <el-form-item label="Payment Method" prop="pay">
                <el-select v-model="formdata.pay" placeholder="Payment Method">
                  <el-option label="Cash" value="Cash"></el-option>
                  <el-option label="Cheque" value="Cheque"></el-option>
                  <el-option label="Card" value="Card"></el-option>
                  <el-option
                    label="Bank Transfer"
                    value="Bank Transfer"
                  ></el-option>
                  <el-option
                    label="Gift Voucher"
                    value="Gift Voucher"
                  ></el-option>
                  <el-option label="Other" value="Other"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                v-if="formdata.pay === 'Cash'"
                label="Deduct from Current Cash Flow "
                prop="cashflow"
              >
                <el-checkbox v-model="formdata.cashflow"
                  >Deduct from Current Cash Flow</el-checkbox
                >
                <p>Can't edit this record latter if deduct</p>
              </el-form-item>

              <el-form-item label="Amount" prop="amount">
                <el-input
                  type="number"
                  v-model.number="formdata.amount"
                  :min="0"
                  class="input-with-select"
                  style="width: 220px"
                  clearable
                >
                  <template slot="prepend">RS</template>
                </el-input>
              </el-form-item>

              <el-form-item
                label="Expense Name"
                prop="name"
                :rules="[
                  { required: true, message: 'Expense name', trigger: 'blur' },
                ]"
              >
                <el-input placeholder="Name" v-model="formdata.name"></el-input>
              </el-form-item>

              <el-form-item label="Expense Note" prop="note">
                <el-input type="textarea" v-model="formdata.note"></el-input>
              </el-form-item>

              <el-form-item class="pt-2" style="margin-bottom: 0px">
                <el-button type="primary" @click="submitForm('formdata')"
                  >Add</el-button
                >
                <el-button @click="resetForm('formdata', true)">Reset</el-button>
              </el-form-item>
            </el-form>
          </el-card>
          <span slot="footer" class="dialog-footer">
            <el-button type="danger" @click="dialogFormVisible2 = false"
              >Cancel</el-button
            >
            <!-- <el-button type="primary" @click="submitForm('formdata')">Add</el-button> -->
          </span>
        </el-dialog>
      </div>
      <div class="col-sm-12 col-md-8 col-lg-6 m-auto pl-4">
        <el-dialog
          title="Edit Expense"
          :visible.sync="dialogFormVisible3"
          :width="width"
        >
          <!-- <h4 class="text-center pt-4 pb-3">Add Expense</h4> -->
          <el-form
            :model="formdata2"
            status-icon
            :rules="rules2"
            ref="formdata2"
            label-width="120px"
            :label-position="labelPosition"
            size="medium"
            style="
              border: 1px solid #e2e2e2;
              border-radius: 5px;
              background-color: #fff;
              padding: 25px;
            "
          >
            <el-form-item label="Store" prop="store">
              <el-select v-model="formdata2.store" placeholder="Select Store">
                <el-option
                  v-for="(store, i) in stores"
                  :key="i"
                  :value="store.id"
                  :label="store.name"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="Expense Main Category" prop="cat">
              <el-select
                v-model="formdata2.cat"
                placeholder="Expense Main Category"
              >
                <el-option
                  v-for="(cat, key) in expenseCategories"
                  :key="key"
                  :value="key"
                  >{{ key }}</el-option
                >
              </el-select>
            </el-form-item>
            <el-form-item
              v-if="formdata2.cat"
              label="Expense Sub Category"
              prop="subcat"
            >
              <el-select
                v-model="formdata2.subcat"
                placeholder="Expense Sub Category"
              >
                <el-option
                  v-for="(subcat, key) in expenseCategories[formdata.cat]"
                  :key="key"
                  :value="key"
                  >{{ key }}</el-option
                >
              </el-select>
            </el-form-item>

            <!-- <el-form-item prop="date" label="Date">
              <el-date-picker
                type="date"
                :picker-options="{
                  disabledDate: (time) => disabledDate(time),
                }"
                placeholder="Pick a date"
                v-model="formdata2.date"
              ></el-date-picker>
            </el-form-item> -->

            <el-form-item label="Payment Method" prop="pay">
              <el-select v-model="formdata2.pay" placeholder="Payment Method">
                <el-option label="Cash" value="Cash"></el-option>
                <el-option label="Cheque" value="Cheque"></el-option>
                <el-option label="Card" value="Card"></el-option>
                <el-option
                  label="Bank Transfer"
                  value="Bank Transfer"
                ></el-option>
                <el-option
                  label="Gift Voucher"
                  value="Gift Voucher"
                ></el-option>
                <el-option label="Other" value="Other"></el-option>
              </el-select>
            </el-form-item>

            <!-- Enabling date edit cause to hard to handle report daily data updates -->
            <!-- <el-form-item
              v-if="formdata2.pay === 'Cash'"
              label="Deduct from Current Cash Flow"
              prop="cashflow"
            >
              <el-checkbox v-model="formdata2.cashflow"
                >Deduct from Current Cash Flow</el-checkbox
              >
            </el-form-item> -->

            <el-form-item label="Amount" prop="amount">
              <el-input
                type="number"
                v-model.number="formdata2.amount"
                class="input-with-select"
                style="width: 220px"
                clearable
              >
                <template slot="prepend">RS</template>
              </el-input>
            </el-form-item>

            <el-form-item
              label="Expense Name"
              prop="name"
              :rules="[
                { required: true, message: 'Expense name', trigger: 'blur' },
              ]"
            >
              <el-input placeholder="Name" v-model="formdata2.name"></el-input>
            </el-form-item>

            <el-form-item label="Expense Note" prop="note">
              <el-input type="textarea" v-model="formdata2.note"></el-input>
            </el-form-item>

            <el-form-item class="pt-2" style="margin-bottom: 0px">
              <el-button type="primary" @click="update('formdata2')"
                >Update</el-button
              >
              <!-- <el-button @click="resetForm('formdata2')">Reset</el-button> -->
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button type="danger" @click="dialogFormVisible3 = false"
              >Cancel</el-button
            >
            <!-- <el-button type="primary" @click="submitForm('formdata')">Add</el-button> -->
          </span>
        </el-dialog>
      </div>
      <b-container class="col-lg-10 mt-1">
        <h3 class="text-info text-center my-4">Expenses</h3>
        <!-- User Interface controls -->
        <el-card
          shadow="always"
          style="background-color: #f5f7fa; overflow: initial"
        >
          <b-row>
            <b-col sm="3" class="my-1">
              <b-form-group label="" class="mb-0">
                <el-date-picker
                  size="medium"
                  v-model="month"
                  :picker-options="{
                    disabledDate: (time) => disabledDate(time),
                  }"
                  type="month"
                  placeholder="Month"
                >
                </el-date-picker>
              </b-form-group>
            </b-col>
            <b-col sm="3" class="my-1">
              <b-form-group label="" class="mb-0">
                <b-form-select
                  placeholder="Store Location"
                  v-model="storeLocation"
                  :options="stores"
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col sm="3" class="my-1">
              <b-form-group label="" class="mb-0">
                <b-form-select
                  placeholder="Main Category"
                  v-model="mainCategory"
                  :options="mainCategories"
                  @change="
                    (value) => {
                      mainCategory = value;
                      subCategories = [
                        {
                          value: null,
                          text: 'Select Sub Category',
                          disabled: true,
                        },
                      ];
                      subCategory = null;
                      Object.keys(expenseCategories[mainCategory]).forEach(
                        (subcat, index) => subCategories.push(subcat)
                      );
                    }
                  "
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col sm="3" class="my-1">
              <b-form-group label="" class="mb-0">
                <b-form-select
                  placeholder="Sub Category"
                  v-model="subCategory"
                  :options="subCategories"
                  @change="
                    (value) => {
                      subCategory = value;
                    }
                  "
                ></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" class="my-1">
              <b-form-group label="" class="mb-0">
                <el-button
                  style="display: block; margin: 0 auto; margin-top: 10px"
                  type="primary"
                  size="medium"
                  @click="searchExpenses"
                  >Search</el-button
                >
              </b-form-group>
            </b-col>
          </b-row>
        </el-card>
        <!-- Main table element -->
        <el-card style="overflow-x: scroll;" shadow="always">
          <b-table
            show-empty
            stacked="sm"
            :items="items"
            :fields="fields"
            :hover="true"
            head-variant="dark"
            :dark="false"
            :small="true"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :empty-text="emptyText"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            @filtered="onFiltered"
            class="mt-4"
          >
            <!-- <template slot="index" slot-scope="data">
          {{data.index + 1}}
        </template> -->

            <template slot="id" slot-scope="row">
              <div>{{ row.value }}</div>
            </template>
            <!-- <template slot="date" slot-scope="row">
              <div >{{ row.value }}</div>
            </template> -->

            <template slot="actions" slot-scope="row">
              <!-- <div class="btn-group" role="group" aria-label="Basic example">
            
              <a @click.stop="row.toggleDetails"><el-button type="primary" size="mini">View</el-button></a>
              <a :href="`tel:${row.item.telephone}`" ><el-button type="success" size="mini">Call</el-button></a>
              <a :href="`sms:${row.item.telephone}`"><el-button type="info" size="mini">SMS</el-button></a>
            
          </div> -->
              <div class="btn-group" role="group" aria-label="Basic example">
                <!-- <a
                  size="sm"
                  @click.stop="row.toggleDetails"
                  class="btn btn-sm btn-primary text-white"
                >
                  View
                </a> -->

                <!-- ********************
                  can be disabled (old records before 2024/ march) for other payments methods 
                  if they have updated to cash to card or other payment method 
                  when creating deduct option is checked
              ***************************************-->
                <button
                  :disabled="row.item.cashflow" 
                  size="sm"
                  @click="showUpdate(row.item)"
                  class="btn btn-sm btn-primary text-white"
                >
                  Edit
                </button>
              </div>
            </template>
          </b-table>
        </el-card>
        <b-col md="3" class="my-1">
          <b-form-group class="mb-0">
            <b-form-select v-model="perPage">
              <option disabled>per page</option>
              <option :value="10">10</option>
              <option :value="25">25</option>
              <option :value="50">50</option>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="6" class="my-1">
          <b-pagination
            :total-rows="totalRows"
            :per-page="perPage"
            v-model="currentPage"
            class="my-0"
          />
        </b-col>
      </b-container>
    </div>
  </div>
</template>

<script>
import db from "../../config/FirebaseInit";
import firebase from "firebase/app";
const items = [];
export default {
  name: "expenses",
  data() {
    return {
      emptyText: "Loading Records...",
      items: [],
      fields: [
        { key: "name", label: "Name", sortable: true },
        {
          key: "date",
          label: "Date",
          sortable: false,
          // formatter: value => {
          //   return value.toLocaleString()
          // }
        },
        { key: "cat", label: "Category", sortable: true },
        { key: "subcat", label: "Sub Category", sortable: true },
        { key: "amount", label: "Amount (Rs)", sortable: true },
        { key: "pay", label: "Payment Method", sortable: true },
        { key: "createdBy", label: "Created By", sortable: true },
        { key: "updatedBy", label: "Updated By", sortable: true },
        { key: "updated", label: "Updated", sortable: true },
        { key: "note", label: "Note", sortable: false },
        { key: "actions", label: "Actions" },
      ],
      payments: [],
      amount: 0,
      stores: this.$store.state.stores,
      dialogFormVisible: false,
      dialogFormVisible2: false,
      dialogFormVisible3: false,
      width: "50%",
      currentPage: 1,
      perPage: 10,
      totalRows: items.length,
      pageOptions: [10, 25, 50],
      sortBy: null,
      sortDesc: false,
      filter: null,
      loading: false,
      loading1: false,
      loading2: false,
      changed: true,
      cus: 0,
      pay: 0,
      expenseCategories: {},
      initExpAmount: 0,
      categories: {},
      mainCategories: [],
      mainCategory: "",
      subCategories: [],
      subCategory: "",
      month: new Date(),
      storeLocation: this.$store.state.selectedStore,
      formdata: {
        name: "",
        cat: "",
        subcat: "",
        date: "",
        note: "",
        pay: "",
        cashflow: false,
        amount: 0,
        store: this.$store.state.selectedStore,
      },
      formdata2: {
        name: "",
        cat: "",
        subcat: "",
        date: "",
        note: "",
        pay: "",
        cashflow: false,
        amount: 0,
        store: "",
        id: "",
      },
      rules2: {
        store: [
          { required: true, message: "Please select store", trigger: "change" },
        ],
        amount: [
          { required: true, message: "Please input amount", trigger: "blur" },
          {
            min: 0.0,
            type: "number",
            message: "Minimum amount is 0",
            trigger: "blur",
          },
        ],
        cat: [
          {
            required: true,
            message: "Please select main category",
            trigger: "change",
          },
        ],
        subcat: [
          {
            required: true,
            message: "Please select sub category",
            trigger: "change",
          },
        ],
        pay: [
          {
            required: true,
            message: "Please select payment method",
            trigger: "change",
          },
        ],
        date: [
          { required: true, message: "Please select date", trigger: "change" },
        ],
      },
      labelPosition: "top",
    };
  },

  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    open1() {
      this.$notify.error({
        title: "Error",
        message: "Please Enter the Correct Details",
        type: "error",
      });
    },
    showUpdate(item) {
      this.formdata2.name = item.name;
      this.formdata2.cat = item.cat;
      this.formdata2.subcat = item.subcat;
      this.formdata2.amount = item.amount;
      this.formdata2.pay = item.pay;
      this.formdata2.cashflow = item.cashflow;
      this.formdata2.store = item.store;
      this.formdata2.note = item.note;
      this.formdata2.date = item.date;
      this.dialogFormVisible3 = true;
      this.formdata2.id = item.id;
      this.initExpAmount = item.amount;
    },

    updateStore(store, expense, date) {
      date = new Date(date);
      this.$store.state.secondaryDatabase
        .collection("stores")
        .doc(store)
        .get()
        .then((doc) => {
          if (doc.exists) {
            let dailyData;
            if (date.toLocaleDateString() == new Date().toLocaleDateString()) {
              dailyData = doc.data().dailyData;
              if (
                dailyData &&
                dailyData.date == new Date().toLocaleDateString()
              ) {
                dailyData.expenses += expense;
                console.log("dailyData", dailyData);
              } else {
                dailyData = {
                  date: new Date().toLocaleDateString(),
                  sales: 0,
                  expenses: expense,
                  profit: 0,
                  due: 0,
                };
              }
            }
            const updateObj = { totalExp: doc.data().totalExp + expense };
            if (dailyData) updateObj.dailyData = dailyData;
            this.$store.state.secondaryDatabase
              .collection("stores")
              .doc(store)
              .update(updateObj)
              .then((doc) => {})
              .catch((error) => alert(error));
          } else {
          }
        })
        .catch((error) => alert(error));
    },

    updateReport(expDate, store, expense) {
      const date = new Date(expDate);
      const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      this.$store.state.secondaryDatabase
        .collection("reports")
        .where("date", ">=", firebase.firestore.Timestamp.fromDate(firstDay))
        .where("date", "<=", firebase.firestore.Timestamp.fromDate(lastDay))
        .where("storeLocation", "==", store)
        .get()
        .then((querySnapshot) => {
          const data = {};
          let isReportExsists = false;
          querySnapshot.forEach((doc) => {
            isReportExsists = true;
            data.id = doc.id;
            data.totalExp = doc.data().totalExp;
          });
          if (!isReportExsists) {
            const analyticsReport = {};
            const profitReport = {};
            Object.keys(this.categories).forEach((key, index) => {
              analyticsReport[key] = {};
              profitReport[key] = {};
              Object.keys(this.categories[key]).forEach((subcat, index) => {
                analyticsReport[key][subcat] = 0;
                profitReport[key][subcat] = 0;
              });
            });
            this.$store.state.secondaryDatabase
              .collection("reports")
              .add({
                date: firebase.firestore.Timestamp.fromDate(new Date(expDate)),
                storeLocation: store,
                reportData: analyticsReport,
                profitData: profitReport,
                totalSales: 0,
                totalProfit: 0,
                totalRemaining: 0,
                totalPurcCost: 0,
                totalPurcDue: 0,
                totalExp: expense,
              })
              .then((doc) => {})
              .catch((error) => alert(error));
            // console.log("this.analyticsReport is", this.analyticsReport);
          } else {
            this.$store.state.secondaryDatabase
              .collection("reports")
              .doc(data.id)
              .update({ totalExp: data.totalExp + expense })
              .then((docRef) => {})
              .catch((error) => alert(error));
          }
        })
        .catch((error) => alert(error));
    },

    updateCashFlow(store, expense, expenseName) {
      this.$store.state.secondaryDatabase
        .collection("cashflow")
        .where("isCurrent", "==", true)
        .where("store", "==", store)
        .get()
        .then((querySnapshot) => {
          const data = {};
          let isCashFlowExsists = false;
          querySnapshot.forEach((doc) => {
            isCashFlowExsists = true;
            data.id = doc.id;
            data.cashData = doc.data().cashData;
            data.deduct = doc.data().deduct;
          });
          const dataRow = {
            type: "deduct",
            amount: expense,
            date: firebase.firestore.Timestamp.now(),
            note: expenseName,
          };
          if (!isCashFlowExsists) {
            this.$store.state.secondaryDatabase
              .collection("cashflow")
              .add({
                // notes: this.notesData, // will asign when updating since undefined here
                open: 0,
                store: store,
                start: firebase.firestore.Timestamp.now(),
                close: 0,
                sales: 0,
                add: 0,
                deduct: expense,
                inRegi: 0,
                diff: 0,
                desc: "",
                cashData: [dataRow],
                isCurrent: true,
                updated: firebase.firestore.Timestamp.now(),
                createdBy: this.$store.state.systemUser.name,
              })
              .then((doc) => {})
              .catch((error) => alert(error));
            // console.log("this.analyticsReport is", this.analyticsReport);
          } else {
            data.cashData.push(dataRow);
            data.deduct += expense;
            this.$store.state.secondaryDatabase
              .collection("cashflow")
              .doc(data.id)
              .update({
                deduct: data.deduct,
                cashData: data.cashData,
                updated: firebase.firestore.Timestamp.now(),
                updatedBy: this.$store.state.systemUser.name,
              })
              .then((docRef) => {})
              .catch((error) => alert(error));
          }
        })
        .catch((error) => alert(error));
    },

    // updateDailyData(date, expense, store) {
    //   if (date.toLocaleDateString() !== new Date().toLocaleDateString()) return;

    //   const itemKey = `dailyData-${store}`;
    //   const dailyData = JSON.parse(localStorage.getItem(itemKey));
    //   if (dailyData && dailyData.date == new Date().toLocaleDateString()) {
    //     dailyData.expenses += expense;
    //     localStorage.setItem(itemKey, JSON.stringify(dailyData));
    //     console.log("dailyData", dailyData);
    //   } else {
    //     const dailyData = {
    //       date: new Date().toLocaleDateString(),
    //       sales: 0,
    //       expenses: expense,
    //       profit: 0,
    //       due: 0,
    //     };
    //     localStorage.setItem(itemKey, JSON.stringify(dailyData));
    //   }
    // },

    update(fdata) {
      this.$refs[fdata].validate((valid) => {
        if (valid) {
          (this.dialogFormVisible3 = false), (this.changed = false);
          this.loading = true;
          ////console.log(user)
          this.$store.state.secondaryDatabase
            .collection("expenses")
            .doc(this.formdata2.id)
            .update({
              name: this.formdata2.name,
              cat: this.formdata2.cat,
              subcat: this.formdata2.subcat,
              amount: this.formdata2.amount,
              pay: this.formdata2.pay,
              cashflow: this.formdata2.cashflow,
              store: this.formdata2.store,
              note: this.formdata2.note,
              date: new Date(this.formdata2.date),
              updated: firebase.firestore.Timestamp.now(),
              updatedBy: this.$store.state.systemUser.name,
            })
            .then((docRef) => {
              //console.log('docref', docRef.id)
              var newItems = this.items.filter((item) => {
                ////console.log('filfkkk')
                if (item.id == this.formdata2.id) {
                  // console.log('hjghkhjhjghjg', this.formdata2)
                  (item.name = this.formdata2.name),
                    (item.cat = this.formdata2.cat),
                    (item.subcat = this.formdata2.subcat),
                    (item.amount = this.formdata2.amount),
                    (item.pay = this.formdata2.pay),
                    (item.store = this.formdata2.store),
                    (item.note = this.formdata2.note),
                    (item.date = this.formdata2.date.toLocaleString());
                  // item.id = this.formdata2 // bcz formdata2.id is deleted
                  (item.updated = firebase.firestore.Timestamp.now()
                    .toDate()
                    .toLocaleString()),
                    (item.updatedBy = this.$store.state.systemUser.name);
                }
                // console.log('item',item)
                return item;
              });
              // console.log('newItems', newItems)
              this.items = newItems;
              if (this.initExpAmount !== this.formdata2.amount) {
                const amount = this.formdata2.amount - this.initExpAmount;
                this.updateStore(
                  this.formdata2.store,
                  amount,
                  this.formdata2.date
                );
                this.updateReport(
                  this.formdata2.date,
                  this.formdata2.store,
                  amount
                );
                // this.updateDailyData(
                //   this.formdata2.date,
                //   amount,
                //   this.formdata2.store
                // );
              } else {
                // this.updateStore(this.formdata2.store, this.formdata2.amount,this.formdata2.date);
                // this.updateReport(
                //   this.formdata2.date,
                //   this.formdata2.store,
                //   this.formdata2.amount
                // );
              }
              
              // this.formdata2.id = expId
              // this.items.push(this.formdata2)

              // this.$store.state.expenses = this.items;
              this.resetForm(this.formdata);
              this.loading = false;
              this.changed = true;
              this.$notify({
                title: "Success",
                message: "Expense updated",
                type: "success",
              });
            })
            .catch((error) => alert(error));
        } else {
          this.open1();
          return false;
        }
      });
    },
    submitForm(fdata) {
      this.$refs[fdata].validate((valid) => {
        if (valid) {
          (this.dialogFormVisible2 = false), (this.changed = false);
          this.loading = true;
          ////console.log(user)
          this.$store.state.secondaryDatabase
            .collection("expenses")
            .add({
              ...this.formdata,
              updated: firebase.firestore.Timestamp.now(),
              createdBy: this.$store.state.systemUser.name,
            })
            .then((docRef) => {
              //console.log('docref', docRef.id)
              const item = {id: docRef.id};
              item.name = this.formdata.name;
              item.cat = this.formdata.cat;
              item.subcat = this.formdata.subcat;
              item.amount = this.formdata.amount;
              item.pay = this.formdata.pay;
              item.store = this.formdata.store;
              item.note = this.formdata.note;
              item.date = this.formdata.date.toLocaleString();
              item.cashflow = this.formdata.cashflow;
              item.updated = firebase.firestore.Timestamp.now()
                .toDate()
                .toLocaleString();
              item.createddBy = this.$store.state.systemUser.name;
              this.items.push(item);
              // this.items = this.$store.state.expenses;
              this.totalRows = this.items.length;
              this.updateStore(
                this.formdata.store,
                this.formdata.amount,
                this.formdata.date
              );
              this.updateReport(
                this.formdata.date,
                this.formdata.store,
                this.formdata.amount
              );
              // this.updateDailyData(
              //   this.formdata.date,
              //   this.formdata.amount,
              //   this.formdata.store
              // );
              if (this.formdata.cashflow) {
                this.updateCashFlow(
                  this.formdata.store,
                  this.formdata.amount,
                  this.formdata.name
                );
              }
              // this.$store.state.secondaryDatabase
              //   .collection("shops")
              //   .doc(firebase.auth().currentUser.uid)
              //   .update({
              //     cus: this.cus,
              //   })
              //   .then(() => {
              //     //console.log('secondaryDB shop id')
              //   })
              //   .catch((error) => alert(error));
              this.resetForm(this.formdata);
              this.loading = false;
              this.changed = true;
              this.$notify({
                title: "Success",
                message: "Expense added",
                type: "success",
              });
            })
            .catch((error) => alert(error));
        } else {
          this.open1();
          return false;
        }
      });
    },
    disabledDate(date) {
      return date > new Date();
    },
    searchExpenses() {
      if (this.month === "") {
        return alert("Please select month");
      }
      if (!this.storeLocation) {
        return alert("Please select store location");
      }
      this.loading1 = true;
      this.changed = false;
      this.items = [];
      this.getExpenses(this.month, this.storeLocation);
    },
    getExpenses(dateToGetRecord, storeToGet) {
      const store = storeToGet ? storeToGet : this.$store.state.selectedStore;
      const date = dateToGetRecord ? new Date(dateToGetRecord) : new Date();
      const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      console.log("store", store, date, firstDay, lastDay);
      const docRef = this.$store.state.secondaryDatabase.collection("expenses");
      let firestoreQuery = docRef;
      if (!dateToGetRecord) firestoreQuery = firestoreQuery.limit(10);
      firestoreQuery
        .where("date", ">=", firebase.firestore.Timestamp.fromDate(firstDay))
        .where("date", "<=", firebase.firestore.Timestamp.fromDate(lastDay))
        .where("store", "==", store)
        .orderBy("date", "desc")
        // .where("date", ">=", firebase.firestore.Timestamp.fromDate(firstDay))
        // .where("date", "<=", firebase.firestore.Timestamp.fromDate(lastDay))
        // .where("store", "==", store)
        // .orderBy("date", "desc")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const data = doc.data();
            data.id = doc.id;
            data.date = doc.data().date.toDate().toLocaleDateString();
            data.updated = doc.data().updated
              ? doc.data().updated.toDate().toLocaleString()
              : "";
            // if (data.date != undefined) {
            //   data.date = doc.data().date.toDate().toLocaleString();
            // }
            this.items.push(data);

            this.totalRows = this.items.length;
            // this.$store.state.expenses = this.items;
          });
          if (this.items.length == 0) {
            this.emptyText = "There are no records to show";
          }
          this.loading1 = false;
          this.changed = true;
        })
        .catch((error) => console.log(error));
    },
    resetForm(formName, reset) {
      if (reset) this.$refs[formName].resetFields();
      if (!reset) {
        formName.name = "";
        formName.cat = "";
        formName.subcatubcat = "";
        formName.amountmount = "";
        formName.pay = "";
        formName.store = "";
        formName.note = "";
        formName.date = "";

        formName.id = formName.id ? "" : delete formName.id;
      }
      
    },
  },
  created() {
    this.loading1 = true;
    this.changed = false;
    if (screen.width > 767) {
      this.width = "50%";
    } else {
      this.width = "85%";
    }
    this.$store.state.secondaryDatabase
      .collection("shops")
      .doc(firebase.auth().currentUser.uid)
      .get()
      .then((doc) => {
        this.cus = doc.data().cus;
        this.pay = doc.data().pay;
        this.expenseCategories = doc.data().expenseCategories || {};
        this.categories = doc.data().categories;
        this.mainCategory = Object.keys(this.expenseCategories)[0];
        Object.keys(this.expenseCategories)
          .sort()
          .forEach((key, index) => this.mainCategories.push(key));
        if (this.mainCategory) {
          Object.keys(this.expenseCategories[this.mainCategory])
            .sort()
            .forEach((subcat, index) => this.subCategories.push(subcat));
        }
      })
      .catch((error) => console.log(error));
    // this.$store.state.secondaryDatabase
    //   .collection("stores")
    //   .get()
    //   .then((querySnapshot) => {
    //     querySnapshot.forEach((doc) => {
    //       const data = {
    //         id: doc.id,
    //         value: doc.data().name,
    //         text: doc.data().name,
    //         name: doc.data().name,
    //       };
    //       this.stores.push(data);
    //     });
    //   })
    //   .catch((error) => alert(error.message));
    this.getExpenses();
    // if (this.$store.state.expenses.length != 0) {
    //   this.items = this.$store.state.expenses;
    //   this.totalRows = this.items.length;
    //   this.loading1 = false;
    //   this.changed = true;
    // } else {

    //}
  },
};
</script>

<style scoped>
@import url("~@/assets/admin/css/admin-loader.css");
</style>




// WEBPACK FOOTER //
// src/components/admin/Expenses.vue